import React from 'react';
import { Link } from 'react-router-dom';
import { VersionInfo } from './VersionInfo';

interface FooterProps {
  className?: string;
}

export const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  return (
    <footer className={`bg-white border-t border-gray-200 py-4 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="text-sm text-gray-600">
            © 2026 SmartCatalog. All rights reserved.
          </div>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-gray-700">Privacy</Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-gray-700">Terms</Link>
            <VersionInfo variant="footer" />
          </div>
        </div>
      </div>
    </footer>
  );
};